import type { CatalogEntry } from '../types';

/** Health (feature `12`) error codes + catalog. Populated in Phase 3. */
export const HEALTH_CODES = {} as const;
export const HEALTH_CATALOG: Record<string, CatalogEntry> = {};
